'use strict';

/**
 * UTC time in seconds, counted from January 1, 1970.
 *
 * @export
 */
export type TimeSinceEpoch = number;
